(function () {
    'use strict';
    angular
        .module('app')
        .constant('ALFABETO', 'abcdefghijklmnñopqrstuvwxyz')
        .constant('ALFABETOingles', 'abcdefghijklmnopqrstuvwxyz')
        // Nº de elementos por página en las tablas
        .constant('NG_TABLE_DEFAULT_PARAMS_PUBLIC', {size: 50})
        // Nº de milisegundos para actualizar el contador de notificaciones
        .constant('NOTIFICACIONES_TIME', 30000)
        // Nº de últimas notificaciones que se muestran
        .constant('NOTIFICACIONES_COUNT', 10)
        // Tiempo mínimo de lectura de una página para actualizar el avance
        .constant('MIN_TIEMPO_PAGINA', 10000)
        .constant('TAMANO_FUENTES', ["14px", "18px", "22px", "28px", "40px"])
        .constant('COLORES_FONDO', ["white", "rgb(251, 240, 217)", "black"])
        .constant('TIPOS_FUENTE', ["Arial, sans-serif", "Times, serif", "Trebuchet MS", "Verdana, sans-serif"])
        .constant('INTERLINEADOS', ["1em", "1.25em", "1.8em"])
        .constant('NG_LIST_DEFAULT_PARAMS_PUBLIC', {size: 50})
        .constant('NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP', {size: 20})
    ;
})();
